import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = ({ invertColors = false }) => {
  const baseClass = `px-4 font-extrabold ${
    invertColors ? 'lg:text-white hover:text-gray-400' : 'text-gray-500 hover:text-blue-900'
  }`;
const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -110; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
}

  return (
    <>
      <HashLink className={baseClass} smooth to="/#" scroll={el => scrollWithOffset(el)}>
        Início
      </HashLink>
      <HashLink className={baseClass} smooth to="/#sobre" scroll={el => scrollWithOffset(el)}>
        Sobre
      </HashLink>
      <HashLink className={baseClass} smooth to="/produtos#" scroll={el => scrollWithOffset(el)}>
        Produtos
      </HashLink>
      <HashLink className={baseClass} to="/contato#" scroll={el => scrollWithOffset(el)}>
        Contato
      </HashLink>
      {/* <HashLink
        className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
        smooth
        to="/get-demo#demo"
      >
        Demo our products
      </HashLink> */}
    </>
  );
};

export default NavLinks;
